import basicController from "servicestack/basic.controller.properties";
import Product from "emun.shopping/product.model";
import templateUrl from "emun.swatch/swatch-counts.htm";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import SwatchCountPrompt from "emun.swatch/swatchcount-prompt";
import swatchConfig from "emun.swatch/swatch.config";
import EmailPrompt from "emun.swatch/email-count-prompt";

class SwatchCountsController {
  constructor($window, Lightbox) {
    let $ctrl = this;
    basicController(this);
    $ctrl.swatchConfig = swatchConfig;
    let options = {
      url: "QuerySwatchCounts.json",
      orderBy: "-Date,Id",
      pageSize: 12,
      views: {
        list: "th-list",
        cards: "th",
      },
      filters: [
        { groupBy: "Status", title: "Status" },
        { date: "Date", title: "Created Date" },
      ],
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      append: false,
      scrub(response) {
        response.data.results = Product.map(response.data.results);
      },
      onLoaded: function (args) {
        $ctrl.images = [];
        args.results.forEach(function (arg) {
          $ctrl.images.push({
            thumbUrl: arg.getImageUrl("large"),
            url: arg.getImageUrl("large"),
          });
        });
      },
      criteria: {
        //status: 'Active'
      },
      sortOptions: {
        Id: "Id: Low to High",
        "-Id": "Id: High to Low",
        CountName: "Count Name: Low to High",
        "-CountName": "Count Name: High to Low",
        Date: "Created: Newest",
        "-Date": "Created: Oldest",
        "Status,Id": "Status: A to Z",
        "-Status,Id": "Status: Z to A",
      },
    };
    this.$window = $window;
    this.query = new AutoQuery(options);
    $ctrl.query.criteria.countType = $ctrl.countType || "swatch";
    this.bus = this.query.bus;
    this.selectAll = false;
  }
  create() {
    const $ctrl = this;
    SwatchCountPrompt.open({ model: {countType: $ctrl.query.criteria.countType} }).then(() => $ctrl.load());
  }
  emailCount(count) {
    let $ctrl = this;
    if (count.countType.toUpperCase() == "STOCK") {
      EmailPrompt({ count: count});
    } else {
      $ctrl.$window.location =
      "mailto:" +
      count.retailerEmail +
      "?subject=Swatch%20Count&body=" +
      $ctrl.$window.location.protocol +
      "//" +
      $ctrl.$window.location.hostname +
      $ctrl.swatchConfig.emailLink +
      count.id;
    }
  }
  view(count) {
    const $ctrl = this;
    $ctrl.$state.transitionTo("swatch.editcount", { countId: count.id });
  }
  $onInit() {
    const $ctrl = this;
  }
  load() {
    return this.query.load();
  }

  deleteCount(m) {
    let $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Count")
      .result.then(function () {
        return $ctrl.bus.send("DeleteSwatchCount", m).then(function (response) {
          $ctrl.query.load(true);
        });
      });
  }
}

export default {
  bindings: {
    countType: "@"
  },
  controller: SwatchCountsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
